import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "d-block pt-2" }
const _hoisted_2 = { class: "form-label fw-bolder" }
const _hoisted_3 = {
  key: 1,
  class: "d-block pt-2"
}
const _hoisted_4 = { class: "form-check align-items-start" }
const _hoisted_5 = ["textContent"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = {
  key: 2,
  class: "d-block pt-2"
}
const _hoisted_8 = { class: "d-block" }
const _hoisted_9 = { class: "form-label fw-bolder" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = {
  key: 0,
  class: "d-block pt-2"
}
const _hoisted_12 = { class: "form-label fw-bolder" }
const _hoisted_13 = { class: "me-1" }
const _hoisted_14 = { class: "me-1" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_16 = { class: "d-flex justify-content-end mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_FormInputClearable = _resolveComponent("FormInputClearable")!
  const _component_Badge = _resolveComponent("Badge")!
  const _component_Btn = _resolveComponent("Btn")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    show: _ctx.canExportPrices,
    title: _ctx.t('ExportCatalog'),
    "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('update:show'))),
    closeOnOuterClick: false
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
      }, [
        _createElementVNode("label", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.t('CatalogCode')), 1),
          _createElementVNode("div", null, _toDisplayString(_ctx.data.catalog.code), 1)
        ]),
        (_ctx.isLoadingJobs)
          ? (_openBlock(), _createBlock(_component_Spinner, { key: 0 }))
          : (_ctx.canExportPrices)
            ? (_openBlock(), _createElementBlock("label", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _withDirectives(_createElementVNode("input", {
                    name: "exportPrices",
                    type: "checkbox",
                    class: "form-check-input me-2",
                    value: "true",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.models.exportPrices) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.models.exportPrices]
                  ]),
                  _createElementVNode("span", {
                    textContent: _toDisplayString(_ctx.t('ExportPrices')),
                    class: "form-check-label text-break user-select-none pis-label"
                  }, null, 8, _hoisted_5),
                  _hoisted_6,
                  _createElementVNode("small", null, _toDisplayString(_ctx.t('ExportPricesDescription')), 1)
                ])
              ]))
            : _createCommentVNode("", true),
        (_ctx.models.exportPrices)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("label", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.t('Emails')), 1),
                _createVNode(_component_FormInputClearable, {
                  "model-value": _ctx.models.emails,
                  rows: 3,
                  validators: _ctx.validators.emails,
                  "onUpdate:modelValue": _ctx.onEmailsUpdate
                }, null, 8, ["model-value", "validators", "onUpdate:modelValue"]),
                _hoisted_10,
                _createElementVNode("small", null, _toDisplayString(_ctx.t('EmailsDescription')), 1)
              ]),
              (_ctx.lastScheduledJob)
                ? (_openBlock(), _createElementBlock("label", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.t('LastScheduledJob')), 1),
                    _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.lastScheduledJob.catalog?.code), 1),
                    _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.lastScheduledJob.type), 1),
                    _createVNode(_component_Badge, {
                      class: "ms-auto",
                      textContent: _toDisplayString(_ctx.lastScheduledJob.status)
                    }, null, 8, ["textContent"])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _hoisted_15,
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_Btn, {
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.close()), ["prevent"])),
            class: "mx-2"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('Cancel', true)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Btn, {
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.onExport()), ["prevent"])),
            disabled: !_ctx.isFormValid,
            primary: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('Export', true)), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ], 32)
    ]),
    _: 1
  }, 8, ["show", "title"]))
}